// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3094":"c5665f01","9091":"bd0b27fa","9911":"bd0b27fa"}[chunkId] + ".chunk.css";
};